import { IAudienceMetaRecord } from '@/Interfaces/Audiences/Audience.interface';
import { memo } from 'react';

interface IProps {
  orGroup: IAudienceMetaRecord[];
}

const AudienceOrGroup = memo(({ orGroup }: IProps) => (
  <>
    {(orGroup ?? []).map((audience, audienceIndex, arr) => (
      <span key={audience.id}>
        {audience.name}
        {audienceIndex !== arr.length - 1 && <span className='text-[#F00]'> OR </span>}
      </span>
    ))}
  </>
));

export default AudienceOrGroup;
